import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicLocation({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 .65a5.75 5.75 0 015.75 5.75c0 1.06-.29 1.9-.95 3.1l-.22.4-.16.25c-.47.74-1.32 1.92-2.54 3.55l-.89 1.16a1.25 1.25 0 01-1.98 0l-.7-.9A47.72 47.72 0 013.43 9.9l-.21-.4a6.02 6.02 0 01-.96-3.1A5.75 5.75 0 018 .65zm0 1.5A4.25 4.25 0 003.75 6.4c0 .7.18 1.27.67 2.2l.25.45.13.23c.46.75 1.36 2.02 2.72 3.79l.48.62.67-.89a61.07 61.07 0 002.48-3.45l.19-.3c.65-1.15.91-1.84.91-2.65 0-2.35-1.9-4.25-4.25-4.25zm0 2.1a2.15 2.15 0 110 4.3 2.15 2.15 0 010-4.3zm0 1.3a.85.85 0 100 1.7.85.85 0 000-1.7z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicLocation.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicLocation.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicLocation svgRef={ref} {...props} />);
export default ForwardRef;
